export enum LogKind {
    Add = 0,
    Edit = 1,
    Delete = 2
}